// export const IMAGE_BASE_URL = 'https://flirttool.com/media/'
export const IMAGE_BASE_URL = 'https://flirttool.com/media/'
export const CLOUD_BASE_URL = 'https://storage.googleapis.com/mazuproductions/'
export const SETUP_COMPLETE_VALUE = 2
